import React, { useEffect, useState, useRef, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import CurrencyInput from 'react-currency-input';
import { URLBunge } from "./Componentes/Config";
import { LogAcesso, AlertForm, AlertRedirect, MascaraCNPJ } from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoExplicacaoCasinha,
  ListaFiltroMes,
  BtFiltroMesAtivo,
  BtFiltroMes,
  LinhaResultadoFornada,
  DataAtualizacaoFornada
} from './Estilos'

import IcoBusca from './Images/ico_search_branco.png'
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function FornadaDeVantagens(props) {

  const history = useHistory();
  const [ Loading, setLoading ] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [ NomeEvento, setNomeEvento ] = useState("Minha Bunge Vendas");
  const [ Token, setToken ] = useState(localStorage.getItem("c_token"));
  const [ IdUser, setIdUser ] = useState(localStorage.getItem("id_tb_user"));
  const [ CPFUser, setCPFUser ] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
        history.push({ pathname: '/', state: {} });
    } else {
        LogAcesso(Token, "Fornada de Vantagens")
    }
  }, []);








  const [ NumClientesCarteira, setNumClientesCarteira ] = useState(0);
  const [ NumClientesCadastrados, setNumClientesCadastrados ] = useState(0);
  const [ NumPercentualCadastro, setNumPercentualCadastro ] = useState(0);
  const [ NumClientesCadastrosMes, setNumClientesCadastrosMes ] = useState(0);
  const [ NumclientesComCompras, setNumclientesComCompras ] = useState(0);
  const [ DataAtualizacao, setDataAtualizacao ] = useState(0);
  const [ MensagemBack, setMensagemBack ] = useState("");
  const [ ExisteDados, setExisteDados ] = useState(false);

   function BuscaDadosFornada(mesSelecionado, anoSelecionado) {
    var d = new Date();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);
    
    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };
        
    fetch(`${URLBunge}/api/Indicadores/ListarFornadaDeVantagens/`+anoSelecionado+`/`+mesSelecionado, requestOptions)
      .then(response => response.json())
      .then(result => {

        // console.log(result)
        if(result.sucesso === true) {
          setNumClientesCarteira(result.clientesCarteira);
          setNumClientesCadastrados(result.clientesCadastrados);
          setNumPercentualCadastro(result.percentualCadastro);
          setNumClientesCadastrosMes(result.clientesCadastrosMes);
          setNumclientesComCompras(result.clientesComCompras);
          setDataAtualizacao(result.data);
          setExisteDados(result.sucesso);
          setCarregandoResultado(false);
        } else {
          setExisteDados(result.sucesso);
          setMensagemBack(result.mensagem);
          setCarregandoResultado(false);
        }

      })
      .catch(error => console.log('error', error));
   }

  function MostraDataAtualizacao() {
    var dia = DataAtualizacao.substr(8,2);
    var mes = DataAtualizacao.substr(5,2);
    var ano = DataAtualizacao.substr(0,4);
    return <>{dia}/{mes}/{ano}</>;
  }

  const [MesesAno, setMesesAno] = useState([]);

  useEffect(() => {

    var d = new Date();
    var dia = d.getDate();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    var ano2 = d.getFullYear().toString().substr(-2);

    var startDate = "6-21";
    var month = parseInt(startDate.split("-")[0]);
    var year = parseInt(startDate.split("-")[1]);
    
    while(!(year === Number(ano2) && month === mes)){

      if(month<12){
        month++;
      } else {
         month = 1;
         year++;
      }
      var MesAno;
      if(month == 1)  { MesAno = 'JAN'; }
      if(month == 2)  { MesAno = 'FEV'; }
      if(month == 3)  { MesAno = 'MAR'; }
      if(month == 4)  { MesAno = 'ABR'; }
      if(month == 5)  { MesAno = 'MAI'; }
      if(month == 6)  { MesAno = 'JUN'; }
      if(month == 7)  { MesAno = 'JUL'; }
      if(month == 8)  { MesAno = 'AGO'; }
      if(month == 9)  { MesAno = 'SET'; }
      if(month == 10) { MesAno = 'OUT'; }
      if(month == 11) { MesAno = 'NOV'; }
      if(month == 12) { MesAno = 'DEZ'; }

      MesesAno.push({
        id: month+'20'+year,
        Mes: MesAno,
        Ano: '20'+year
      });

    }
    
    // console.log(MesesAno);

    BuscaDadosFornada(mes, ano);

  },[]);

  useEffect(() => {
    setMesSelecionado(MesesAno[MesesAno.length-1].id)
  },[MesesAno]);


  const BtMes = ( item ) => (
      MesSelecionado == item.id ?
        <BtFiltroMesAtivo>{item.Mes}<span>{item.Ano}</span></BtFiltroMesAtivo>
      :
        <BtFiltroMes onClick={()=>SelecionaMes(item.Mes, item.Ano, item.id)}>{item.Mes}<span>{item.Ano}</span></BtFiltroMes>
  );

  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [MesSelecionado, setMesSelecionado] = useState();

  function SelecionaMes(Mes, Ano, Id) {
      setMesSelecionado(Id);

      var MesAno = 0;
      if(Mes == 'JAN') { MesAno = 1; }
      if(Mes == 'FEV') { MesAno = 2; }
      if(Mes == 'MAR') { MesAno = 3; }
      if(Mes == 'ABR') { MesAno = 4; }
      if(Mes == 'MAI') { MesAno = 5; }
      if(Mes == 'JUN') { MesAno = 6; }
      if(Mes == 'JUL') { MesAno = 7; }
      if(Mes == 'AGO') { MesAno = 8; }
      if(Mes == 'SET') { MesAno = 9; }
      if(Mes == 'OUT') { MesAno = 10; }
      if(Mes == 'NOV') { MesAno = 11; }
      if(Mes == 'DEZ') { MesAno = 12; }

      // console.log(MesAno + ' - ' + Ano);

      BuscaDadosFornada(MesAno, Ano);

  }


  const [CarregandoResultado, setCarregandoResultado] = useState(true);
  function LoadResultado() {
    return <>
    <div>Carregando...</div>
    </>
  }


















  return (
    <>  
        <CabecalhoPagina NomeEvento={NomeEvento} />
        {Loading === true ? <Carregando /> : null }

        <BackgroundImg Background={''} BackgroundMob={''} bgcolor={'#FFFFFF'}>
        
            <ColunaRegras>
                <div className={'AreaColunaRegras'}>

                    <TitNoticias>Fornada de Vantagens</TitNoticias>
                    <Clear />

                    <BtVoltar onClick={()=>history.push({ pathname: '/home', state: { } })} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                      <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
                    </BtVoltar>
                    <Clear />

                    <br/>

                    <ListaFiltroMes> { MesesAno.map((item, index) => { return BtMes(item) }) } </ListaFiltroMes>

                    {CarregandoResultado == true ?
                    <LoadResultado />
                  :

                    ExisteDados === false ?
                      <div>{MensagemBack}</div>
                    :
                      <>
                      <LinhaResultadoFornada>
                        <div>Clientes</div>
                        <div>{NumClientesCarteira}</div>
                      </LinhaResultadoFornada>

                      <LinhaResultadoFornada>
                        <div>Cadastrados</div>
                        <div>{NumClientesCadastrados}</div>
                      </LinhaResultadoFornada>

                      <LinhaResultadoFornada>
                        <div>Percentual</div>
                        <div>{NumPercentualCadastro}%</div>
                      </LinhaResultadoFornada>

                      <LinhaResultadoFornada>
                        <div>Cadastros mês</div>
                        <div>{NumClientesCadastrosMes}</div>
                      </LinhaResultadoFornada>

                      <LinhaResultadoFornada>
                        <div>Com compras</div>
                        <div>{NumclientesComCompras}</div>
                      </LinhaResultadoFornada>

                      <DataAtualizacaoFornada>Data da atualização: {MostraDataAtualizacao()}</DataAtualizacaoFornada>
                      </>                      
                    }
                      





                    <TextoExplicacaoCasinha>
                      A cada novo cadastro e  movimentação de conta cadastrada você ganha pontos e moedas:
                      <br/>A cada cliente cadastrado = 5 pontos + 2 moedas; Toda movimentação da base de frequência/mês = 5 pontos + 2 moedas; A cada cliente que resgatar no mês = 10 pontos + 2 moedas; Cadastrar no programa 50% da sua base de clientes aptos* = 10 pontos + 25 moedas; Cadastrar no programa 100% da sua base de clientes aptos* = 50 pontos + 50 moedas.
                      <br/><br/>* Base de clientes a serem cadastrados a partir do mês de lançamento do Game.
                    </TextoExplicacaoCasinha>

                    
                </div>  
            </ColunaRegras>
            
            <MenuPrinc Pagina="Pesquisas" />
         </BackgroundImg>
    </>
  );

}

export default FornadaDeVantagens;
